import { Container, Flag, Image, Menu } from "semantic-ui-react";
import React, { useEffect, useState } from "react";
import { MediaConsumer, MediaProvider, MenuConsumer, MenuProvider, utils } from "@devgateway/wp-react-lib";
import { injectIntl } from "react-intl";
import { withRouter } from "react-router";
import SearchComponent from './SearchControl';
import LangSwitcher from "./LangSwitcher";
const getPath = (menu, match) => {
  let path = [];
  menu.items.forEach(item => {
    if (item.child_items) {
      item.child_items.forEach(ch => {
        if (ch.slug == match.params.slug) {
          path.push(item);
          path.push(ch);
        }
      });
    } else if (item.slug == match.params.slug && item.url != '/') {
      path.push(item);
    }
  });
  return path;
};
const localReplaceLink = (url, locale) => {
  if (url) {
    if (!url.substr(url.indexOf("/wp") + 3).startsWith("/" + locale)) {
      return "/" + locale + url.substr(url.indexOf("/wp") + 3);
    }
    return url.substr(url.indexOf("/wp") + 3);
  }
  return "";
};
const BreadCrumbs = withRouter(injectIntl(({
  menu,
  match,
  intl
}) => {
  let path = getPath(menu, match);
  return /*#__PURE__*/React.createElement(React.Fragment, null, path.filter(i => i.url != "#wpm-languages").map(i => !i.child_items ? /*#__PURE__*/React.createElement("a", {
    className: i.slug == match.params.slug ? 'active' : '',
    href: utils.replaceLink(i.url, intl.locale)
  }, " ", i.post_title) : /*#__PURE__*/React.createElement("span", null, i.post_title, " ")));
}));

/*
Setting objects will inject customization preview
* */
const MenuItems = injectIntl(withRouter(({
  settings,
  withIcons,
  active,
  menu,
  onSetSelected,
  selected,
  match,
  intl: {
    locale
  },
  isSmallScreen
}) => {
  useEffect(e => {
    if (!selected) {
      const pathSelected = getPath(menu, match);
      const items = pathSelected.filter(i => i.menu_item_parent == 0);
      if (items) {
        onSetSelected(items[0]);
      }
    }
  }, [match, menu, onSetSelected, selected]);

  /*Original menu mixed with customization changes*/
  const [mixedMenu, setMixedMenu] = useState(null);
  //const [removedItems, setRemoved] = useState(null)

  useEffect(() => {
    setMixedMenu(menu);
  }, [menu]);
  useEffect(() => {
    if (settings && settings.menu_settings && mixedMenu) {
      const removed = [];
      const newItems = menu.items.map(item => {
        //if menu exists in partial settings
        //if item  deleted
        if (settings.menu_settings && settings.menu_settings["nav_menu_item[" + item.ID + "]"] === false) {
          removed.push(item.ID);
        }
        //if item  removed
        if (settings.menu_settings && settings.menu_settings["nav_menu_item[" + item.ID + "]"]) {
          const updatedItem = settings.menu_settings["nav_menu_item[" + item.ID + "]"];
          return {
            ...item,
            ...settings.menu_settings["nav_menu_item[" + item.ID + "]"]
          };
        } else {
          return item;
        }
      });
      //if item is new
      Object.keys(settings.menu_settings).map(mk => {
        const value = settings.menu_settings[mk];
        if (value.type == 'nav_menu_item') {
          const re = /(-)?[0-9]+/g;
          const results = re.exec(mk);
          const id = parseInt(results[0]);
          const exists = newItems.find(m => m.ID == id);
          if (!exists) {
            newItems.push(value.value);
          }
        }
      });
      setMixedMenu({
        ...menu,
        items: newItems.filter(i => removed.indexOf(i.ID) === -1)
      });

      /*
      const items = menu.items.map(item => {
          if (settings.menu_settings && settings.menu_settings["nav_menu_item[" + item.ID + "]"]) {
              return {...item, ...settings.menu_settings["nav_menu_item[" + item.ID + "]"]}
          } else {
              return item;
          }
      })*/

      //  setMixedMenu({...menu, items:newItems})
    }
  }, [settings]);
  const [isMobileResolution, setIsMobileResolution] = useState(false);
  useEffect(() => {
    const handleResize = () => {
      setIsMobileResolution(window.innerWidth <= 1024);
    };

    // Initial check and event listener
    handleResize();
    window.addEventListener('resize', handleResize);

    // Cleanup on unmount
    return () => window.removeEventListener('resize', handleResize);
  }, []);
  return mixedMenu && /*#__PURE__*/React.createElement(React.Fragment, null, mixedMenu.items.filter(i => i.url !== "#wpm-languages").map((item, index) => /*#__PURE__*/React.createElement(React.Fragment, {
    key: item.ID
  }, /*#__PURE__*/React.createElement(Menu.Item, {
    className: `divided ${item.child_items ? 'has-child-items' : ''} 
                            ${selected && selected.ID === item.ID ? 'selected' : ''} 
                            ${active === item.slug ? "active" : ""}`
  }, withIcons && /*#__PURE__*/React.createElement("a", {
    href: localReplaceLink(item.url, locale)
  }, /*#__PURE__*/React.createElement("div", {
    className: "mark"
  }, /*#__PURE__*/React.createElement("span", {
    className: "sr-only"
  }, item.title))), isSmallScreen ? item.child_items ? /*#__PURE__*/React.createElement("span", {
    onClick: () => onSetSelected(selected === item ? null : item)
  }, item.title) : /*#__PURE__*/React.createElement("a", {
    href: localReplaceLink(item.url, locale)
  }, item.title) : item.child_items ? /*#__PURE__*/React.createElement("span", {
    onMouseOver: e => onSetSelected(item)
  }, item.title) : /*#__PURE__*/React.createElement("a", {
    onMouseOut: e => onSetSelected(null),
    onMouseOver: e => onSetSelected(item),
    href: localReplaceLink(item.url, locale)
  }, item.title)), isMobileResolution && selected && selected.ID === item.ID && selected.child_items && /*#__PURE__*/React.createElement(React.Fragment, null, selected.child_items.map(childItem => /*#__PURE__*/React.createElement(Menu.Item, {
    key: childItem.ID,
    className: `divided child-item ${active === childItem.slug ? "active" : ""}`
  }, /*#__PURE__*/React.createElement("div", {
    className: "mark"
  }), /*#__PURE__*/React.createElement("a", {
    href: localReplaceLink(childItem.url, locale)
  }, childItem.title)))))));
}));
const Header = ({
  intl,
  match,
  settings
}) => {
  const [selected, setSelected] = useState();
  const [isMenuVisible, setMenuVisible] = useState(false);
  const [isSmallScreen, setIsSmallScreen] = useState(false); // State to track small screen
  const [hasInteracted, setHasInteracted] = useState(false); // Track user interaction

  const {
    slug
  } = match.params;
  const toggleMenu = () => {
    setHasInteracted(true); // Ensures animations are only enabled after this interaction
    setMenuVisible(prevState => !prevState);
  };
  useEffect(() => {
    // Function to update isSmallScreen state
    const updateScreenSize = () => {
      setIsSmallScreen(window.innerWidth <= 1024); // Check if width is 1024px or lower
    };

    // Initial check
    updateScreenSize();

    // Event listener for window resize
    window.addEventListener('resize', updateScreenSize);

    // Cleanup
    return () => window.removeEventListener('resize', updateScreenSize);
  }, []);
  const [isMediumScreen, setIsMediumScreen] = useState(false); // State to track small screen

  useEffect(() => {
    // Function to update isMediumScreen state
    const updateScreenSize = () => {
      setIsMediumScreen(window.innerWidth <= 1365); // Check if width is 1365px or lower
    };

    // Initial check
    updateScreenSize();

    // Event listener for window resize
    window.addEventListener('resize', updateScreenSize);

    // Cleanup
    return () => window.removeEventListener('resize', updateScreenSize);
  }, []);
  const Logo = ({
    media
  }) => {
    return media ? /*#__PURE__*/React.createElement(Image, {
      src: media.guid.rendered
    }) : /*#__PURE__*/React.createElement("img", {
      className: "brand logo",
      size: "large",
      src: "/logo_full.png"
    });
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(MenuProvider, {
    slug: "main",
    locale: intl.locale
  }, /*#__PURE__*/React.createElement(Container, {
    key: "header-container",
    fluid: true,
    className: "header"
  }, /*#__PURE__*/React.createElement("div", {
    className: `hamburger-menu ${hasInteracted ? 'animate' : ''} ${isMenuVisible ? 'open' : 'close'}`,
    onClick: toggleMenu
  }, /*#__PURE__*/React.createElement("div", null), /*#__PURE__*/React.createElement("div", {
    className: "middle-line"
  }), /*#__PURE__*/React.createElement("div", null)), /*#__PURE__*/React.createElement(Container, {
    fluid: true,
    className: "background"
  }, /*#__PURE__*/React.createElement(Menu, {
    className: "branding",
    text: true
  }, /*#__PURE__*/React.createElement(Menu.Item, null, /*#__PURE__*/React.createElement("a", {
    href: "https://tobaccocontroldata.org/en"
  }, settings.site_logo !== 0 && !isMediumScreen && /*#__PURE__*/React.createElement(MediaProvider, {
    id: settings.site_logo
  }, /*#__PURE__*/React.createElement(MediaConsumer, null, /*#__PURE__*/React.createElement(Logo, {
    key: "logo"
  }))), settings.site_logo === 0 && !isMediumScreen && /*#__PURE__*/React.createElement("img", {
    className: "brand logo",
    size: "large",
    src: "/logo_full.png"
  }), isMediumScreen && /*#__PURE__*/React.createElement("img", {
    className: "brand logo small",
    size: "small",
    src: "/TCDI-Icon-small_02.png"
  }))), /*#__PURE__*/React.createElement(Menu.Item, {
    className: "divider"
  }, /*#__PURE__*/React.createElement("div", null)), /*#__PURE__*/React.createElement(Menu.Item, {
    fitted: true,
    href: "/"
  }, /*#__PURE__*/React.createElement(Flag, {
    name: "za"
  }), /*#__PURE__*/React.createElement("div", {
    className: "site name"
  }, settings.name)), isSmallScreen ? /*#__PURE__*/React.createElement(Menu, {
    className: `pages ${isMenuVisible ? 'show' : ''}`
  }, /*#__PURE__*/React.createElement(Container, {
    fluid: true
  }, /*#__PURE__*/React.createElement(MenuConsumer, null, /*#__PURE__*/React.createElement(MenuItems, {
    key: "items",
    settings: settings,
    active: slug,
    selected: selected,
    onSetSelected: setSelected,
    isSmallScreen: isSmallScreen
  })))) : /*#__PURE__*/React.createElement(Menu.Menu, {
    className: "pages"
  }, /*#__PURE__*/React.createElement(MenuConsumer, null, /*#__PURE__*/React.createElement(MenuItems, {
    key: "items",
    settings: settings,
    active: slug,
    selected: selected,
    onSetSelected: setSelected
  }))), /*#__PURE__*/React.createElement(Menu.Item, null, /*#__PURE__*/React.createElement(MenuConsumer, null, /*#__PURE__*/React.createElement(LangSwitcher, {
    key: "lang",
    locale: intl.locale
  }))), /*#__PURE__*/React.createElement(Menu.Item, {
    fitted: true
  }, /*#__PURE__*/React.createElement(SearchComponent, {
    onSetSelected: setSelected,
    settings: settings
  })))), /*#__PURE__*/React.createElement(Container, {
    fluid: true,
    className: "child"
  }, selected && selected.child_items && /*#__PURE__*/React.createElement(Menu, {
    fluid: true,
    text: true
  }, /*#__PURE__*/React.createElement(MenuItems, {
    active: slug,
    locale: intl.locale,
    withIcons: true,
    onSetSelected: e => null,
    menu: {
      items: selected.child_items
    }
  })))), /*#__PURE__*/React.createElement(Container, {
    className: "url breadcrumbs"
  }, /*#__PURE__*/React.createElement(MenuConsumer, null, /*#__PURE__*/React.createElement(BreadCrumbs, null)))));
};
export default injectIntl(withRouter(Header));